export default "__VITE_ASSET__CWmB4nXR__"